// @ts-nocheck
/**
 * KPI Mock Data - 20+ comprehensive KPI metrics
 */

import { generateKpiMetric } from './helpers';

export const mockKpiMetrics = [
  generateKpiMetric({ title: 'Total Users', baseValue: 12453, trendDirection: 'up', trendValue: 12.5 }),
  generateKpiMetric({ title: 'Active Users', baseValue: 8234, trendDirection: 'up', trendValue: 8.3 }),
  generateKpiMetric({ title: 'New Sign-ups', baseValue: 342, trendDirection: 'down', trendValue: -3.2 }),
  generateKpiMetric({ title: 'Monthly Revenue', baseValue: 45231, unit: '$', trendDirection: 'up', trendValue: 15.7 }),
  generateKpiMetric({ title: 'Average Order Value', baseValue: 127, unit: '$', trendDirection: 'up', trendValue: 4.2 }),
  generateKpiMetric({ title: 'Conversion Rate', baseValue: 3.4, unit: '%', trendDirection: 'down', trendValue: -0.8 }),
  generateKpiMetric({ title: 'Churn Rate', baseValue: 2.1, unit: '%', trendDirection: 'down', trendValue: -0.3 }),
  generateKpiMetric({ title: 'Customer Satisfaction', baseValue: 4.6, unit: '/5', trendDirection: 'up', trendValue: 2.2 }),
  generateKpiMetric({ title: 'API Requests', baseValue: 1234567, trendDirection: 'up', trendValue: 23.1 }),
  generateKpiMetric({ title: 'Error Rate', baseValue: 0.12, unit: '%', trendDirection: 'down', trendValue: -45.2 }),
  generateKpiMetric({ title: 'Response Time', baseValue: 234, unit: 'ms', trendDirection: 'down', trendValue: -12.3 }),
  generateKpiMetric({ title: 'Uptime', baseValue: 99.98, unit: '%', trendDirection: 'up', trendValue: 0.02 }),
  generateKpiMetric({ title: 'Storage Used', baseValue: 2.3, unit: 'TB', trendDirection: 'up', trendValue: 18.5 }),
  generateKpiMetric({ title: 'Active Sessions', baseValue: 1543, trendDirection: 'up', trendValue: 7.2 }),
  generateKpiMetric({ title: 'Pending Tasks', baseValue: 87, trendDirection: 'down', trendValue: -15.4 }),
  generateKpiMetric({ title: 'Completed Tasks', baseValue: 456, trendDirection: 'up', trendValue: 32.1 }),
  generateKpiMetric({ title: 'Team Members', baseValue: 24, trendDirection: 'up', trendValue: 4.3 }),
  generateKpiMetric({ title: 'Projects Active', baseValue: 12, trendDirection: 'neutral' }),
  generateKpiMetric({ title: 'Budget Utilization', baseValue: 67, unit: '%', trendDirection: 'up', trendValue: 5.2 }),
  generateKpiMetric({ title: 'Support Tickets', baseValue: 43, trendDirection: 'down', trendValue: -22.3 }),
  generateKpiMetric({ title: 'Email Open Rate', baseValue: 24.5, unit: '%', trendDirection: 'up', trendValue: 3.7 }),
  generateKpiMetric({ title: 'Click-Through Rate', baseValue: 2.8, unit: '%', trendDirection: 'up', trendValue: 1.2 }),
];

// Sparkline data for KPI cards
export const generateSparklineData = (days: number = 30) => {
  return Array.from({ length: days }, (_, i) => Math.floor(50 + Math.random() * 50 + i * 0.5));
};

export const mockKpiWithSparklines = mockKpiMetrics.slice(0, 12).map((kpi, idx) => ({
  ...kpi,
  sparklineData: generateSparklineData(30),
}));
